// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.T4m8fnshAxC39expoZYY{align-items:center;display:flex}.rh6A4a6Geo4sFi6WOm4B .vhtPk0XRh8gnNrq10WX6{margin-left:4px}.rh6A4a6Geo4sFi6WOm4B .zP9eRg7yY347wGH0pdVs{margin-left:6px}.zP9eRg7yY347wGH0pdVs{color:var(--content-primary-primary);max-width:220px;margin-left:8px}.WTz8cWYUG4U4wMY8S6Qn{color:var(--content-neutral-primary);margin-left:8px}.KtpbisqcV7cuUUc4onO0{background:var(--background-brand-subtle-primary);color:var(--content-primary-tertiary)}.uNpFocuQ5qY8Wv98oyNX{color:var(--content-primary-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `T4m8fnshAxC39expoZYY`,
	"wrap--checkbox": `rh6A4a6Geo4sFi6WOm4B`,
	"wrapCheckbox": `rh6A4a6Geo4sFi6WOm4B`,
	"icon": `vhtPk0XRh8gnNrq10WX6`,
	"title": `zP9eRg7yY347wGH0pdVs`,
	"count": `WTz8cWYUG4U4wMY8S6Qn`,
	"highlighter": `KtpbisqcV7cuUUc4onO0`,
	"highlighter--label": `uNpFocuQ5qY8Wv98oyNX`,
	"highlighterLabel": `uNpFocuQ5qY8Wv98oyNX`
};
export default ___CSS_LOADER_EXPORT___;
